import React, { useState } from "react";
import { Plus, Maximize2, Minimize2 } from "lucide-react";

const PANEL_WIDTH = 559;

interface CaseSidePanelProps {
  headerName: string;
  addEnabled?: boolean;
  onAdd?: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  isSidebarOpen: boolean;
  enableExpansion?: boolean;
}

export default function CaseSidePanel({
  headerName,
  addEnabled = false,
  onAdd,
  onClose,
  children,
  isSidebarOpen,
  enableExpansion = false,
}: CaseSidePanelProps) {

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div
        className="
        fixed
        inset-0
        bg-[rgba(10,10,10,0.20)]
        z-[105]
        "
        style={{
          top: "var(--maintenance-banner-height, 0px)",
          right: isSidebarOpen ? 48 : 0,
        }}
        onClick={onClose} 
      />

      <div
        className="
          fixed
          bg-white
          border-l border-[#E5E5E5]
          shadow-xl
          flex flex-col
          z-[110]
          transition-all duration-300
        "
        style={{
          top: "var(--maintenance-banner-height, 0px)",
          height: "calc(100vh - var(--maintenance-banner-height, 0px))",
          width: isExpanded
            ? `calc(100vw - ${isSidebarOpen ? 48 : 0}px)`
            : PANEL_WIDTH,
          right: isSidebarOpen ? 48 : 0,
        }}
        onClick= {(e)=> e.stopPropagation()}
      >
        <div
          className="
            h-[48px] 
            px-4 py-2 
            flex items-center justify-between
            border-b border-[#E5E5E5]
            shrink-0 
            bg-gray-50 
          "
        >
          <div className="flex items-center gap-4">
            <button
              onClick={onClose}
              className="
                flex items-center justify-center
                rounded
                hover:bg-gray-200 
                transition-colors
              "
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M5 14.1667L9.16667 9.99999L5 5.83333M10.8333 14.1667L15 9.99999L10.8333 5.83333"
                  stroke="#64748B"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {enableExpansion && (
              <button
                onClick={() => setIsExpanded((prev) => !prev)}
                className="h-5 w-5 flex items-center justify-center rounded-md hover:bg-gray-200 transition-colors"
              >
                {isExpanded ? (
                  <Minimize2 className="w-4 h-4 text-[#64748B]" />
                ) : (
                  <Maximize2 className="w-4 h-4 text-[#64748B]" />
                )}
              </button>
            )}

            <span
              className="
                text-[#070B24]
                font-semibold 
                text-base
                select-none
              "
            >
              {headerName}
            </span>
          </div>

          {addEnabled && (
            <button
              onClick={onAdd}
              className="
                h-5 w-5 
                flex items-center justify-center
                rounded-md
                shadow-xs
                hover:bg-gray-50
                transition-colors
              "
            >
              <Plus className="w-4 h-4 text-indigo-500" />
            </button>
          )}
        </div>

        <div className="h-full min-w-0 break-words">{children}</div>
      </div>
    </>
  );
}